import { render, staticRenderFns } from "./GuideItemEditor.vue?vue&type=template&id=ab4e3dee&"
import script from "./GuideItemEditor.vue?vue&type=script&lang=js&"
export * from "./GuideItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GuideItemEditor.vue"
export default component.exports